module.exports = __webpack_public_path__ + "img/table-edit.40a0e9bb.svg";